import { Order } from '../../types/order'

/**
 * The auth state which, when combined with the auth methods, make up the return object of the `useOrder` hook.
 */
export interface OrderState {
	listenNewOrders: boolean
	orders: Order[]
	isLoading: boolean
	hasNewOrder: boolean
	error?: Error
}

/**
 * The initial auth state.
 */
export const initialOrderState: OrderState = {
	listenNewOrders: false,
	orders: [],
	hasNewOrder: false,
	isLoading: false,
}
